import { useQuery, useInfiniteQuery } from '@tanstack/react-query'
import {
  getListListingOffice,
  getListListingInactive,
  getListListingDetail,
  getListingImages,
  getDetailListingOffice,
  getListLocation
} from "./api"

export const useGetListListingOffice = ({ params, enabled }) => {
  return useQuery({
    queryKey: ['get-list-listing-office', params],
    queryFn: () => getListListingOffice(params),
    enabled
  })
}

export const useGetListListingInactive = ({ params, enabled }) => {
  return useQuery({
    queryKey: ['get-list-listing-inactive', params],
    queryFn: () => getListListingInactive(params),
    enabled
  })
}

export const useGetListListingDetail = ({ slug, enabled }) => {
  return useQuery({
    queryKey: ['get-list-listing-detail', slug],
    queryFn: () => getListListingDetail(slug),
    enabled
  })
}

export const useGetListingImages = ({ slug, enabled }) => {
  return useQuery({
    queryKey: ['get-listing-images', slug],
    queryFn: () => getListingImages(slug),
    enabled
  })
}

export const useGetDetailListingOffice = ({ slug, enabled }) => {
  return useQuery({
    queryKey: ['get-detail-listing-office', slug],
    queryFn: () => getDetailListingOffice(slug),
    enabled
  })
}

export const useGetListLocation = ({ params, options = {} }) => {
  return useInfiniteQuery({
    queryKey: ['get-list-location', params],
    queryFn: ({ pageParam = 1 }) => getListLocation({ ...params, page: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      return !!lastPage?.data?.data?.length ? allPages.length + 1 : undefined;
    },
    ...options
  })
}